import { ReactNode, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { SvgHelperWrapper } from '../Icon/iconHelper';
import ChevronSvg from './assets/chevron.svg';
import { msgs } from './messages';
import * as S from './styles';

export { SLIDE_BUTTON_INDENT, SLIDE_BUTTON_SIZE } from './styles';

type ReactResponsiveCarouselProps = {
  children: ReactNode[];
  className?: string;
  showIndicators?: boolean;
  slideButtonType?: S.SlideButtonProps['$buttonType'];
};

export const ReactResponsiveCarousel = ({
  children,
  className,
  showIndicators,
  slideButtonType,
}: ReactResponsiveCarouselProps) => {
  const intl = useIntl();

  const renderArrowNext = useCallback(
    (onClick: () => void, hasNext: boolean) => {
      return (
        hasNext && (
          <S.SlideButtonNext
            aria-label={intl.formatMessage(msgs.slideButtonNext)}
            data-testid="slideButtonNext"
            onClick={onClick}
            $buttonType={slideButtonType}
          >
            <SvgHelperWrapper Svg={ChevronSvg} />
          </S.SlideButtonNext>
        )
      );
    },
    [intl, slideButtonType],
  );

  const renderArrowPrev = useCallback(
    (onClick: () => void, hasPrev: boolean) => {
      return (
        hasPrev && (
          <S.SlideButtonPrev
            aria-label={intl.formatMessage(msgs.slideButtonPrev)}
            data-testid="slideButtonPrev"
            onClick={onClick}
            $buttonType={slideButtonType}
          >
            <ChevronSvg />
          </S.SlideButtonPrev>
        )
      );
    },
    [intl, slideButtonType],
  );

  const [activeSlideNumber, setActiveSlideNumber] = useState(0);

  const handleChange = useCallback(
    (activeSlideNumber: number) => setActiveSlideNumber(activeSlideNumber),
    [],
  );

  return (
    <S.ReactResponsiveCarousel
      className={className}
      onChange={handleChange}
      renderArrowNext={renderArrowNext}
      renderArrowPrev={renderArrowPrev}
      showIndicators={!!showIndicators}
      showStatus={false}
      showThumbs={false}
      $activeSlideNumber={activeSlideNumber}
    >
      {/* @ts-ignore - ReactChild type compatibility issue with React 18 */}
      {children}
    </S.ReactResponsiveCarousel>
  );
};
